<template>
  <div class="wrap">
    <div class="content">
      <p class="title">{{faceValue}}元话费充值</p>
      <div class="item">
        <span class="label">交易金额</span>
        <span class="detail">{{pricePoint}}积分</span>
      </div>
      <div class="item">
        <span class="label">充值号码</span>
        <span class="detail">{{phone}}</span>
      </div>
      <div class="item">
        <span class="label">交易时间</span>
        <span class="detail">{{createTime}}</span>
      </div>
      <div class="item">
        <span class="label">订单号</span>
        <span class="detail">{{orderno}}</span>
      </div>
      <div class="item">
        <span class="label">订单状态</span>
        <template v-if="chargeStatus == 0">
          <span class="detail">等待充值</span>
        </template>
        <template v-else-if="chargeStatus == 1">
          <span class="detail">充值中</span>
        </template>
        <template v-else-if="chargeStatus == 2">
          <span class="detail">交易完成</span>
        </template>
        <template v-else>
          <span class="detail">交易失败</span>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api";

export default {
  bodyClass: "gray-bg",
  title: "充值账单详情",
  data() {
    return {
      chargeStatus: "",
      createTime: "",
      phone: "",
      pricePoint: "",
      orderno: "",
      faceValue: "",
    }
  },
  methods: {
    getDetail(orderno) {
      api.charge.getDetail(orderno, (res) => {
        this.chargeStatus = res.record.chargeStatus;
        this.createTime = res.record.createTime;
        this.phone = res.record.phone;
        this.pricePoint = res.record.pricePoint;
        this.orderno = res.record.orderno;
        this.faceValue = res.record.faceValue;
      })
    }
  },
  mounted () {
    let orderno = this.$route.query.orderno;
    this.orderno = orderno;
    this.getDetail(orderno)
  },
};
</script>

<style lang="less" scoped>
.wrap {
  padding: 4vw 3vw; 
  .content {
    background: #fff;
    padding: 0 4vw;
    border-radius: 7px;
    padding-bottom: 4.66vw;
    .title {
        padding-top: 7.066vw; 
        padding-bottom: 4.33vw;
        font-size: 4.53vw;
        color: #333;
    }
    .item {
        display: flex;
        align-items: flex-start;
        font-size: 3.7vw;
        margin-bottom: 4.55vw;
        .label {
            color: #999;
            width: 20vw;
        }
        .detail {
            width: 70vw;
            word-break: break-all;
        }
    }
  }
  p {
    margin: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/charge/Detail.vue